module.exports = __webpack_public_path__ + "media/images/app/collections/trejours-favorites-002b8d97dfe7c678838d79f8c3bac77b.webp";